import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Users, Clock, XCircle } from 'lucide-react';

export function ActiveStaffPanel({ activeStaff, handleCheckOut }) {
  return (
    <Card className="shadow-lg border-0">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5" />
            Active Staff on Premises
          </div>
          <Badge className="bg-emerald-600 text-lg px-4 py-1">{activeStaff.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {activeStaff.length === 0 ? (
          <p className="text-center text-slate-500 py-8">No active staff currently</p>
        ) : (
          <div className="space-y-3">
            {activeStaff.map((entry) => (
              <div
                key={entry.id}
                data-testid={'active-staff-' + entry.id}
                className="p-4 bg-slate-50 rounded-lg border flex items-center justify-between"
              >
                <div className="flex-1">
                  <p className="font-bold">{entry.staff_name}</p>
                  <p className="text-sm text-slate-600">Villa {entry.villa_number}</p>
                  <div className="flex items-center gap-2 text-xs text-slate-500 mt-1">
                    <Clock className="w-3 h-3" />
                    <span>Checked in: {new Date(entry.check_in_time).toLocaleTimeString()}</span>
                  </div>
                  <p className="text-xs text-slate-500 mt-1">Pass: {entry.entry_pass_number}</p>
                </div>
                <Button
                  data-testid={'checkout-' + entry.id}
                  onClick={() => handleCheckOut(entry.id)}
                  size="sm"
                  variant="outline"
                  className="text-red-600 hover:bg-red-50"
                >
                  <XCircle className="w-4 h-4 mr-1" />
                  Check Out
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
